<template>
  <nav class="bg-lightgray">
    <div class="mobile-navbar">
      <div
        class="logo-container flex justify-center items-center h-full px-4 py-2 bg-onyx"
      >
        <img
          class="h-full"
          src="../../assets/logo.svg"
          alt="Berghoff Design Group logo"
        />
      </div>
      <span class=" text-center uppercase text-black w-1/3">
        {{ $route.meta.tabName }}
      </span>
      <i
        class="fas fa-bars fa-2x fa-fw text-red text-right w-1/3 mx-4"
        @click="openNavMenu()"
      />
    </div>

    <div class="desktop-navbar h-full">
      <div
        class="logo-container flex justify-center items-center h-full bg-onyx"
      >
        <img
          class="h-16"
          src="../../assets/logo.svg"
          alt="Berghoff Design Group logo"
        />
      </div>

      <div class="flex flex-row px-12 items-center h-full">
        <div class="greeting flex-grow" v-if="userName">
          <i class="bdg-icon user mr-2 align-middle text-2xl text-blue" />
          <span class="align-middle text-lg uppercase">
            Hello, {{ userName }}!
          </span>
        </div>
        <div class="search-settings-logout flex items-center">
          <bdg-search-field
            class="mr-12 md:w-64"
            placeholder-text="Enter keywords"
            @search="globalSearch"
            v-model="searchTerm"
            blue-icon
            v-if="userType === 'admin'"
          />
          <router-link
            class="hover-bold h-full mr-10"
            :to="{ name: 'settings' }"
          >
            <span class="mr-2  align-middle text-lg uppercase">
              settings
            </span>
            <i class="bdg-icon gear align-middle text-2xl text-blue" />
          </router-link>
          <div>
            <a class="hover-bold text-lg" @click="logOut">
              <span class="mr-2 align-middle uppercase">Log Out</span>
              <i class="bdg-icon logout align-middle text-2xl text-blue" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import BdgSearchField from "../../forms/fields/BdgSearchField";
import { logout } from "../../helpers";

export default {
  name: "Navbar",
  components: { BdgSearchField },
  data() {
    return {
      searchTerm: this.$route.params.term || ""
    };
  },
  computed: {
    userName() {
      return this.$store.state.userName;
    },
    userType() {
      return this.$store.state.userType;
    }
  },
  methods: {
    openNavMenu() {
      this.$store.commit("setIsMobileNavOpen", true);
    },
    globalSearch(text) {
      if (text) {
        this.$router.push({
          name: "search-results",
          params: { term: text }
        });
      }
    },
    logOut() {
      logout(this);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.mobile-navbar {
  @apply flex flex-row justify-between items-center w-full h-full;

  @screen md {
    @apply hidden;
  }
}

.desktop-navbar {
  @apply hidden;

  @screen md {
    display: grid;
    grid-template-columns: $sidebar-width 1fr;

    @apply w-full h-full;
  }
}

.router-link-active {
  @apply font-bold;
}
</style>
